import { render } from "./add-tournament.template.html?vue&type=template&id=2ed084e8&scoped=true"
import script from "./AddTournament.vue?vue&type=script&lang=ts"
export * from "./AddTournament.vue?vue&type=script&lang=ts"

import "./AddTournament.vue?vue&type=style&index=0&id=2ed084e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2ed084e8"

export default script